/* global ViewController, WebView, scriptLoader */
var edocSignController = new ViewController({
    directory : "views/public",
    name: "edocSign",
    container: "main",
    route: "doc-sign-public"
}) ;

var PDFJS_LIB = {
    name: "pdf-lib-js",
    type: "js",
    version: "2.9.359",
    localPath: "libs/views/ext/pdfjs/2.9.359/build/pdf.js",
} ;

edocSignController.prepareDataOnEnter = function(token, callback){
    scriptLoader.load(PDFJS_LIB, function(err){
        if(err){ return callback(err) ;}
        this.api.public.getEdocSignature(token, function(err, signBook){
            if(err) {return callback(err) ;}
            var pdfUrl = "";
            if(signBook && signBook.documents){
                pdfUrl = "/api/public/edocGetPdf?token="+token+"&docId="+signBook.documents[0].signBookDocumentId;
            }
            let settings = {} ;
            if(signBook && signBook.signer && signBook.signer.sign){
                settings = signBook.signer.sign.settings;
            }
            return callback(null, { 
                token: token,
                signBook: signBook,
                pdfUrl: pdfUrl,
                settings
            }) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

edocSignController.onValidate = function(){
    this.view.longTask(function(done){
        this.api.public.edocGenerateOtp(this.data.token, function(err, signTokenInfos){
            if(err) { return done(err) ;}
            done() ;
            this.data.signToken = signTokenInfos.signToken;
            var v = new WebView("views/public",  "edocSignPopup") ;
            v.openInPopup({
                closeWithEsc: false,
                closeByClickOutside: false,
                data: this.data.signBook.signer
            });
            v.on("cancel", function(){ v.close() ;}) ;
            v.on("resendCode", function(){ 
                this.view.longTask(function(done){
                    this.api.public.edocRegenerateOtp(this.data.signToken, function(err){
                        if(err) { return done(err) ;}
                        this.view.info(WebView.tr("sign.codeResent")) ;
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
            v.on("validate", function(){
                var data = v.getData() ;
                if(this.data.settings.checkbox_confirm && !data.checkboxConfirmed){
                    this.view.error(WebView.tr("sign.needConfirm", {label: this.data.settings.checkbox_label})) ;
                    return ;
                }
                if(this.data.settings.input_confirm && !data.input_value){
                    this.view.error(WebView.tr("sign.pleaseInput", {label: this.data.settings.input_label})) ;
                    return ;
                }
                var signPng = v.getSign() ;
                var paraphImg = v.getSignParaph();
                this.view.longTask(function(done){
                    this.api.public.edocSign(this.data.signToken, this.data.token, this.data.signBook.signBookId, 
                        data.otp, signPng, paraphImg, data.input_value,
                        function(err){
                        if(err){ 
                            if(err.data && err.data.message === "signature code is wrong" || err.data.message === "Signature code is mandatory to sign"){ 
                                this.view.error(WebView.tr("sign.wrongSignatureCode")+'<br>'+WebView.tr("sign.tryAgain")) ;
                                return done() ; 
                            }
                            return done(err) ; }
                        v.close() ;
                        this.refresh(done) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


edocSignController.onRefuse = function(){
    var v = new WebView("views/public",  "edocRefusePopup") ;
    v.openInPopup({
        closeWithEsc: false,
        closeByClickOutside: false,
        data: {}
    });
    v.on("cancel", function(){ v.close() ;}) ;
    v.on("validate", function(){
        var data = v.getData() ;
        this.view.longTask(function(done){
            this.api.public.edocRefuse(this.data.token, this.data.signBook.signBookId, data.comment, function(err){
                if(err){ return done(err) ; }
                v.close() ;
                this.refresh(done) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;



module.exports = edocSignController ;